import React from "react";

const Modal = ({ close, children }: {close: () => void, children: JSX.Element}) => {
  return (
    <div className="modal-wrapper">
      <div className="close-div" onClick={close}></div>
      {children}
    </div>
  );
};

export default Modal;
